import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import mapSelectorsToProps from 'aria-viewer/core/selectors/mapSelectorsToProps'
import {
    openWelcomeModal,
    closeWelcomeModal,
    setFromVR,
    setRegistrationWelcomePrompt,
} from 'aria-viewer/tour/tourActions'
import { sendHybridAppAnalyticsEvents } from 'aria-viewer/analytics/analyticActions'
import { M_MOBEXP_VR_EXITED } from 'aria-viewer/analytics/constants/mobileAnalytics'
import ActionButton from 'aria-viewer/tour/components/buttons/actionButton'
import Logo from 'aria-viewer/tour/components/logo'
import { WELCOME_PROMPT_HIDDEN, VIDEO_START_TIME, FROM_VR } from 'aria-viewer/tour/constants/queryConstants'
import styleguide from 'aria-viewer/tour/constants/styleGuide'
import uriHandler from 'aria-viewer/utils/uriHandler'
import pure from 'recompose/pure'
import { CTAPrompt } from 'aria-viewer/ctaPrompt'
import CTAPromptTypes from 'aria-viewer/tour/constants/CTAPromptTypes'
import SubmitButton from '../containers/SubmitButton'

const S = {
    mobileFormStyle: {
        getCloseButtonStyle: landscape => {
            return {
                width: '1.1em',
                height: '1.1em',
                position: 'absolute',
                right: '7%',
                top: landscape ? '7%' : '3%',
                zIndex: 2009,
            }
        },
        blueLineStyle: {
            width: 76,
            height: 7,
            position: 'relative',
            display: 'block',
            margin: '4% auto',
            background: styleguide.colors.lightBlue,
        },
        getMainContainerStyle: landscape => {
            return {
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 2008,
                background: styleguide.colors.white,
                padding: '0 1.5%',
                textAlign: 'center',
                overflow: landscape ? 'scroll' : 'hidden',
            }
        },
        getTopContainerStyle: landscape => {
            return {
                position: 'relative',
                width: '100%',
                height: landscape ? 'auto' : '20%',
            }
        },
        titleWrapper: {
            height: 'auto',
            maxHeight: '120px',
            paddingTop: '12.5%',
        },
        experienceText: {
            color: styleguide.colors.grey_3,
            margin: '0 0 7px 0',
            fontWeight: 'ligther',
            fontSize: 16,
            textTransform: 'uppercase',
            letterSpacing: 2,
        },
        locationName: {
            display: '-webkit-inline-box',
            margin: 0,
            textTransform: 'uppercase',
            color: '#444444',
            letterSpacing: 1.5,
            fontWeight: 600,
            fontSize: 20,
            maxWidth: 350,
            maxHeight: 56,
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
        },
        getWelcomeMessagePTagStyle: isSmallScreen => {
            return {
                padding: isSmallScreen ? '0 10%' : '0 20%',
                margin: '2.5% 0',
            }
        },
        welcomeMessageSpanStyle: {
            fontSize: 16,
            fontWeight: styleguide.fonts.weight.lighter,
            color: styleguide.colors.grey_11,
            display: 'inline-block',
        },
        getSubmitButtonWrapper: (vertical, actionCount) => {
            if (vertical && actionCount > 1) {
                return {
                    height: actionCount > 2 ? '30%' : '42.5%',
                }
            } else {
                return { height: '52%' }
            }
        },
        actionButtonsStyle: {
            getContainerStyle: (fromVR, actionCount) => {
                if (fromVR && actionCount < 2) {
                    return {
                        width: '100%',
                        position: 'relative',
                        display: 'inline-block',
                        marginTop: '13%',
                    }
                } else {
                    return {
                        width: '100%',
                        position: 'relative',
                        display: 'inline-block',
                    }
                }
            },
            getActionButtonStyle: (vertical, fromVR, actionCount) => {
                let actionButtonStyle = Object.assign(
                    {},
                    {
                        margin: vertical ? (fromVR ? '3% 0' : '2% 0') : '0 2%',
                        textDecoration: 'none',
                        borderRadius: 5,
                        boxShadow: 'rgba(0, 0, 0, 0.35) 3px 4px 6px 0px',
                        display: 'inline-block',
                        padding: vertical ? (fromVR ? 0 : '0.9em 0') : 0,
                        width: vertical ? '55%' : '28%',
                    },
                    vertical || fromVR
                        ? { height: '3.75em' }
                        : {
                              height: '4.75em',
                              verticalAlign: 'top',
                          }
                )

                if (!vertical && actionCount < 3) {
                    actionButtonStyle = Object.assign({}, actionButtonStyle, {
                        width: actionCount < 2 ? '52%' : '38%',
                    })
                }

                return actionButtonStyle
            },
            getActionLabelStyle: (isSmallScreen, vertical, actionCount) => {
                return Object.assign({}, isSmallScreen ? { fontSize: 12 } : { fontSize: 14, fontWeight: 'lighter' }, {
                    padding: vertical ? 0 : actionCount != 2 ? '0 5%' : '0 25%',
                    position: 'relative',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                })
            },
        },
        getBottomContainerStyle: (vertical, isSmallScreen) => {
            return {
                width: '100%',
                height: isSmallScreen && !vertical ? '30%' : '25%',
                position: 'relative',
            }
        },
        getLogoContainer: (landscape, isSmallScreen) => {
            return {
                padding: landscape ? '10% 0' : isSmallScreen ? '8% 0' : '12% 0',
            }
        },
        logoWrapper: {
            position: 'relative',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            marginTop: 0,
        },
        getPoweredByStyle: isSmallScreen => {
            return Object.assign({}, isSmallScreen ? { fontSize: 10 } : { fontSize: 14, fontWeight: 'lighter' }, {
                display: 'inline-block',
                marginRight: 3,
                marginTop: 0,
            })
        },
        getLogoStyle: isSmallScreen => {
            return {
                display: 'inline-block',
                width: isSmallScreen ? 100 : 120,
                position: 'relative',
                top: 6,
            }
        },
        mobileWhatsNextStyle: {
            getMainContainerStyle: landscape => {
                return {
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: 2008,
                    background: styleguide.colors.white,
                    padding: '0 1.5%',
                    textAlign: 'center',
                    overflow: landscape ? 'scroll' : 'hidden',
                }
            },
            getTopContainerStyle: (landscape, isSmallScreen) => {
                return {
                    position: 'relative',
                    width: '100%',
                    height: landscape ? 'auto' : '20%',
                    marginBottom: isSmallScreen ? '21%' : landscape ? 0 : '26%',
                }
            },
            getTitleWrapper: landscape => {
                return {
                    height: 'auto',
                    maxHeight: '120px',
                    paddingTop: landscape ? '10%' : '20.5%',
                }
            },
            whatsNextTitle: {
                display: 'inline-block',
                margin: 0,
                textTransform: 'uppercase',
                color: '#444444',
                letterSpacing: 1.5,
                fontWeight: 600,
                fontSize: 20,
                maxWidth: 270,
                maxHeight: 56,
                textOverflow: 'ellipsis',
                overflow: 'hidden',
            },
            getActionButtonsWrapper: landscape => {
                return {
                    width: landscape ? '65%' : '100%',
                    position: 'relative',
                    display: 'inline-block',
                }
            },
        },
    },
}

const ActionButtons = pure(function ActionButtons({
    style,
    actions,
    actionCount,
    handleFormClick,
    vertical,
    isSmallScreen,
    fromVR,
}) {
    return (
        actionCount > 0 && (
            <div className="actionsContainer" style={style.getContainerStyle(fromVR, actionCount)}>
                {actions.map((item, index) => {
                    return (
                        <ActionButton
                            onClick={item.actionid == 'register' ? handleFormClick : null}
                            style={style.getActionButtonStyle(vertical, fromVR, actionCount)}
                            labelStyle={style.getActionLabelStyle(isSmallScreen, vertical, actionCount)}
                            action={item}
                            key={index}
                            welcomePrompt={!fromVR}
                        >
                            {item.name}
                        </ActionButton>
                    )
                })}
            </div>
        )
    )
})

const MobileWelcomePrompt = pure(function MobileWelcomePrompt({
    style,
    locationName,
    landscape,
    vertical = false,
    actions,
    actionCount,
    isSmallScreen,
    handleSubmitClick,
    submitLabel,
    handleFormClick,
    fromVR = false,
}) {
    return (
        <div style={style.getMainContainerStyle(landscape)}>
            <div style={style.getTopContainerStyle(landscape)}>
                <div style={style.titleWrapper}>
                    <p style={style.experienceText}>experience</p>
                    <p style={style.locationName}>{locationName}</p>
                </div>

                <p style={style.getWelcomeMessagePTagStyle(isSmallScreen)}>
                    <span style={style.welcomeMessageSpanStyle}>Press start to begin your experience.</span>
                </p>

                <div //the blue line
                    style={style.blueLineStyle}
                />
            </div>

            <div style={style.getSubmitButtonWrapper(vertical, actionCount)}>
                <SubmitButton
                    handleClick={handleSubmitClick}
                    label={submitLabel}
                    isSmallScreen={isSmallScreen}
                    vertical={vertical}
                />
            </div>

            <div style={style.getBottomContainerStyle(vertical, isSmallScreen)}>
                <ActionButtons
                    style={style.actionButtonsStyle}
                    actions={actions}
                    actionCount={actionCount}
                    handleFormClick={handleFormClick}
                    vertical={vertical}
                    isSmallScreen={isSmallScreen}
                    fromVR={fromVR}
                />
                <div style={style.getLogoContainer(landscape, isSmallScreen)}>
                    <Logo
                        isSvg={true}
                        containerStyle={style.logoWrapper}
                        svgLogoStyle={style.getLogoStyle(isSmallScreen)}
                        poweredByStyle={style.getPoweredByStyle(isSmallScreen)}
                    />
                </div>
            </div>
        </div>
    )
})

class WelcomePrompt extends PureComponent {
    constructor(props) {
        super(props)
        this.state = { isVisible: false } // NOT GOOD PRACTICE BUT FOR WELCOME SCREEN
        // WE MAKE AN EXCEPTION :)
    }

    componentWillMount() {
        this.setState({ isVisible: true })
        this.registerNewProps(this.props)
    }

    componentWillReceiveProps(nextProps, nextState) {
        this.registerNewProps(nextProps)
    }

    delayedUpdateURL = () => {
        setTimeout(() => {
            const query = uriHandler.removeQueryParams([VIDEO_START_TIME])
            const path = window.location.origin + window.location.pathname + query
            uriHandler.updateURL(path)
        }, 100)
    }

    handleFormClick = () => {
        const { formClick } = this.props

        if (formClick) formClick()

        //this is to remove vidStart param from the url
        if (uriHandler.hasQueryParam(VIDEO_START_TIME)) {
            this.delayedUpdateURL()
        }
    }

    registerNewProps = newProps => {
        if (this.props.fromVR != newProps.fromVR && newProps.fromVR) {
            this.props.sendHybridAppAnalyticsEvents({ event: M_MOBEXP_VR_EXITED })
        }
    }

    /**
     * handle clicking registration button CTA closing;
     * slightly different. Needed to work around with
     * our code that already existed.
     */
    handleCloseWhatsNext = () => {
        this.handleFormClose({ fromCTARegisterButton: true })
    }

    handleFormClose = ({ fromCTARegisterButton = false }) => {
        const {
            formClose,
            closeWelcomeModal,
            setFromVR,
            isRegistrationEnabled,
            setRegistrationWelcomePrompt,
        } = this.props

        if (formClose) {
            formClose()
        } else if (!fromCTARegisterButton) {
            closeWelcomeModal()
        }

        //this is to remove vidStart param from the url
        if (uriHandler.hasQueryParam(VIDEO_START_TIME)) {
            this.delayedUpdateURL()
        }

        //removes the fromVR param when the form is closed
        if (uriHandler.hasQueryParam(FROM_VR)) {
            let query = uriHandler.addQueryParams({ [WELCOME_PROMPT_HIDDEN]: 1 })
            const path = window.location.origin + window.location.pathname + query

            setFromVR(0)

            if (isRegistrationEnabled) {
                setRegistrationWelcomePrompt(false)
            }
            uriHandler.updateURL(path)
        }
    }

    render() {
        const {
            width,
            height,
            location,
            actionButtons,
            isRegistrationEnabled,
            registrationModalsOpen,
            registrationActionButtons,
            fromVR,
        } = this.props

        const actions = fromVR && isRegistrationEnabled ? registrationActionButtons : actionButtons.get('actions')
        const actionCount = actions.length
        const landscape = width > height
        const isSmallScreen = width <= 320

        let areRegistrationModalsOpen = registrationModalsOpen && Object.keys(registrationModalsOpen).length > 0

        return (
            areRegistrationModalsOpen &&
            this.state.isVisible &&
            //record this event when user exits vr
            //this form will only show when user exits vr
            //sendHybridAppAnalyticsEvents({event: M_MOBEXP_VR_EXITED});
            (fromVR ? (
                <CTAPrompt isModal={false} promptType={CTAPromptTypes.WHATS_NEXT} onClose={this.handleCloseWhatsNext} />
            ) : (
                <MobileWelcomePrompt
                    style={S.mobileFormStyle}
                    locationName={location.name}
                    landscape={landscape}
                    actionCount={actionCount}
                    actions={actions}
                    fromVR={fromVR}
                    isSmallScreen={isSmallScreen}
                    handleFormClick={this.handleFormClick}
                    handleSubmitClick={isRegistrationEnabled ? this.handleFormClick : this.handleFormClose}
                />
            ))
        )
    }
}

export default connect(
    mapSelectorsToProps([
        'actionButtons',
        'isRegistrationEnabled',
        'location',
        'registrationModalsOpen',
        'registrationActionButtons',
        'fromVR',
    ]),
    {
        openWelcomeModal,
        closeWelcomeModal,
        setFromVR,
        setRegistrationWelcomePrompt,
        sendHybridAppAnalyticsEvents,
    }
)(WelcomePrompt)
